import { LocalStorageKey } from '@/constants';
import { firestoreDB } from '@/lib/firebase/firestore';
import { deleteMessagingToken } from '@/lib/firebase/messaging';
import { getAuth, signOut } from 'firebase/auth';
import { clearIndexedDbPersistence, terminate } from 'firebase/firestore';
import { resetUserCookies } from '../cookies.utils';
import { clearStoredSession } from '../localStorage.utils';

const AFFILIATE_SESSION_KEY = 'pmc_ga4_session';

/**
 * Removes every piece of signed-in state this browser keeps, independent of the server.
 * Steps are independent: a failing step is logged and never skips the next one.
 *
 * Firestore cannot be used again in this page once terminated, so callers must
 * reload (or navigate away) after this settles.
 */
export const clearSignedInBrowserState = async () => {
  const steps: Array<[string, () => void | Promise<void>]> = [
    ['cookies', resetUserCookies],
    [
      'web storage',
      () => {
        clearStoredSession(AFFILIATE_SESSION_KEY);
        localStorage.removeItem(LocalStorageKey.tioGuestUuid);
      },
    ],
    [
      'firestore cache',
      async () => {
        await terminate(firestoreDB);
        await clearIndexedDbPersistence(firestoreDB);
      },
    ],
    ['push token', deleteMessagingToken],
    [
      'firebase auth',
      async () => {
        await signOut(getAuth());
      },
    ],
  ];

  for (const [name, step] of steps) {
    try {
      await step();
    } catch (error) {
      console.error(`Clear signed-in state error (${name}):`, error);
    }
  }
};
